// src/components/Hero.jsx
import React from 'react'
import Carousel from './Carousel'
import patternTop from '../assets/pattern-band-top.svg'

const Hero = ({ 
  title, 
  subtitle, 
  backgroundImage, 
  showButtons = false,
  primaryButtonText = "OFANDA CONSULTATION",
  secondaryButtonText = "OFANDA PROPERTIES",
  onPrimaryClick,
  onSecondaryClick,
  carouselItems = []
}) => {
  const carouselContent = carouselItems.map((src, i) => (
    <div key={i} className="w-full h-full">
      <img
        src={src}
        alt={`Slide ${i + 1}`}
        className="w-full h-full object-cover"
        loading="eager"
        fetchpriority="high"
      />
    </div>
  ))

  return (
    <section className="relative min-h-screen bg-ofanda-sand">
      {/* Background carousel layer */}
      {carouselContent.length > 0 && (
        <div className="absolute inset-0 z-0">
          <Carousel
            items={carouselContent}
            autoScroll
            interval={4000}
            className="h-full"
            showControls={false}
            showIndicators={false}
          />
        </div>
      )}

      {/* Afrocentric overlay */}
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-ofanda-ink/70 via-ofanda-ink/20 to-transparent mix-blend-multiply" />

      {/* Pattern bands */}
      <img src={patternTop} alt="pattern" className="absolute top-0 left-0 w-full h-16 object-cover z-10 pointer-events-none select-none" />
      <img src={patternTop} alt="pattern" className="absolute bottom-0 left-0 w-full h-16 rotate-180 object-cover z-10 pointer-events-none select-none" />

      {/* Foreground content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 flex items-center min-h-screen">
        <div className="w-full md:text-left">
          <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-sm font-playfair mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto md:mx-0">
              {subtitle}
            </p>
          )}
          {showButtons && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <button
                onClick={onPrimaryClick}
                className="bg-ofanda-yellow text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition-colors duration-300 transform hover:scale-105"
              >
                {primaryButtonText}
              </button>
              <button
                onClick={onSecondaryClick}
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:scale-105"
              >
                {secondaryButtonText}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Hero